export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY' as const;

export const DATE_FORMATS = {
  'MM/DD/YYYY': 'Month-Day-Year',
  'DD/MM/YYYY': 'Day-Month-Year',
  'YYYY/MM/DD': 'Year-Month-Day',
} as const;

export type DateFormatValues = keyof typeof DATE_FORMATS;

export const DATE_FORMAT_VALUES = Object.keys(
  DATE_FORMATS,
) as DateFormatValues[];

export const DATE_FORMAT_LABELS = Object.values(DATE_FORMATS);

export const getDateFormatLabel = (dateFormat: string) =>
  DATE_FORMAT_VALUES.includes(dateFormat)
    ? DATE_FORMATS[dateFormat as DateFormatValues]
    : dateFormat;
